import React, { FC } from "react";
import {
  createRootRoute,
  createRoute,
  createRouter,
  RouterProvider,
} from "@tanstack/react-router";
import { UnauthenticatedRootPage } from "./UnauthenticatedRootPage";
import { UnauthenticatedPage } from "shared-ts-ui-app-boot";
import { LoginPage } from "../authorization/LoginPage";
import { LoginFailedPage } from "../authorization/LoginFailedPage";
import { LoginCallbackPage } from "../authorization/LoginCallbackPage";
import { LoginProfilePage } from "../authorization/LoginProfilePage";
import { LogoutAction } from "../authorization/LogoutAction";
import { LogoutCallbackAction } from "../authorization/LogoutCallbackAction";

const rootRoute = createRootRoute({
  component: () => <UnauthenticatedRootPage />,
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  component: () => {
    return <UnauthenticatedPage loginPath={"/authentication/login"} />;
  },
});

const splatRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/$",
  component: () => {
    return <UnauthenticatedPage loginPath={"/authentication/login"} />;
  },
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/login",
  component: () => {
    return <LoginPage />;
  },
});

const loginFailedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/login-failed",
  component: () => {
    return <LoginFailedPage />;
  },
});

const loginCallbackRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/login-callback",
  component: () => {
    return <LoginCallbackPage />;
  },
});

const loginProfileRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/login-profile",
  component: () => {
    return <LoginProfilePage />;
  },
});

const logoutActionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/logout",
  component: () => {
    return <LogoutAction />;
  },
});

const logoutCallbackActionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/logout-callback",
  component: () => {
    return <LogoutCallbackAction />;
  },
});

const loggedOutActionRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/authentication/logged-out",
  component: () => {
    return <LogoutCallbackAction />;
  },
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  splatRoute,
  loginRoute,
  loginCallbackRoute,
  loginFailedRoute,
  loginProfileRoute,
  logoutActionRoute,
  logoutCallbackActionRoute,
  loggedOutActionRoute,
]);

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
});

export const AppUnauthenticated: FC = (props) => {
  console.log(
    " AppUnauthenticated **********************************************************"
  );
  console.log("** location.href: ", window.location.href);

  return <RouterProvider router={router} />;
};
